export const PROFILE = 'profile'
export const REGISTRATION = 'registration'
export const BIG_FUTURE = 'bigFuture'

export const FIELD_CONFIRM_PHONE_NUMBER = 'confirmPhoneNumber'
export const FIELD_PHONE_NUMBER = 'phoneNumber'
export const FIELD_RECOVERY_EMAIL = 'recoveryEmail'

export const FIELD_SCHOOLNAME = 'attendingOrgName'
export const FIELD_DISPLAY_SCHOOLNAME = 'attendingOrgDisplayName'
export const FIELD_SCHOOLID = 'attendingOrgId'
export const FIELD_GRADE = 'grade'
export const FIELD_ZIP = 'zip'
export const FIELD_STUDENTID = 'orgStudentId'
export const FIELD_LANG = 'bestLanguageCode'
export const FIELD_ETHNICITY = 'hispanicOriginCodes'
export const FIELD_RACE = 'raceCodes'
export const FIELD_PARENT1 = 'guardian1EducationLevelCode'
export const FIELD_PARENT2 = 'guardian2EducationLevelCode'
export const FIELD_ORG_COUNTRY = 'org_countryCd'
export const FIELD_ORG_CITY = 'org_city'
export const FIELD_ORG_STATE = 'org_stateCd'
export const FIELD_RECOGNIZED_TRIBE = 'enrolledRecognizedTribeInd'
export const FIELD_ENROLLED_TRIBE = 'enrolledTribeCd'
export const FIELD_DESCENDANT_TRIBE = 'descendantTribe'
export const FIELD_DISPLAY_TRIBENAME = 'tribeDisplayName'

export const FIELD_NICKNAME = 'preferredFirstName'
export const FIELD_GENDER = 'gender'
export const FIELD_EMAIL1 = 'emailAddress'
export const FIELD_EMAIL2 = 'email2'
export const FIELD_STREET1 = 'streetAddr1'
export const FIELD_STREET2 = 'streetAddr2'
export const FIELD_STREET3 = 'streetAddr3'
export const FIELD_CITY = 'student_city'
export const FIELD_STATE = 'stateCd'
export const FIELD_POSTALCODE = 'postalCode'
export const FIELD_PROVINCE = 'province'
export const FIELD_COUNTRY = 'countryCd'
export const FIELD_DOMESTIC_INTL = 'domesticOrIntl'
export const FIELD_ETHNICITY_CONSENTED = 'ethnicityConsented'

export const FIELD_MISSING_REG_INFO = 'missingRegInfoInd'

export const ERROR_SERVER = 'root.serverError'
export const ERROR_CONSENT = 'root.consentError'
export const ERROR_GENDER = 'root.genderError'

export const VALUE_FEMALE = 'FEMALE'
export const VALUE_MALE = 'MALE'
export const VALUE_ANOTHER_GENDER = 'ANOTHER'
export const VALUE_DOMESTIC = 'D'
export const VALUE_INTERNATIONAL = 'I'
export const VALUE_DOMESTIC_COUNTRY = 'US'

export const DEFAULT_STUDENT_REGISTRATION_VALUES = {
  [FIELD_DISPLAY_SCHOOLNAME]: '',
  [FIELD_ZIP]: '',
  [FIELD_GRADE]: '',
  [FIELD_STUDENTID]: '',
  [FIELD_LANG]: '',
  [FIELD_PARENT1]: '',
  [FIELD_PARENT2]: '',
  [FIELD_DESCENDANT_TRIBE]: '',
  [FIELD_ENROLLED_TRIBE]: null,
  [FIELD_RECOGNIZED_TRIBE]: null,
  [FIELD_ETHNICITY]: [],
  [FIELD_RACE]: [],
  [FIELD_DISPLAY_TRIBENAME]: '',
}

export const DEFAULT_STUDENT_INFORMATION_VALUES = {
  [FIELD_NICKNAME]: '',
  [FIELD_GENDER]: '',
  [FIELD_EMAIL1]: '',
  [FIELD_EMAIL2]: '',
  [FIELD_STREET1]: '',
  [FIELD_STREET2]: '',
  [FIELD_STREET3]: '',
  [FIELD_CITY]: '',
  [FIELD_STATE]: '',
  [FIELD_POSTALCODE]: '',
  [FIELD_PROVINCE]: '',
  [FIELD_COUNTRY]: 'US',
  [FIELD_DOMESTIC_INTL]: 'D',
}

export const DEFAULT_BIG_FUTURE_VALUES = {
  [FIELD_CONFIRM_PHONE_NUMBER]: '',
  [FIELD_PHONE_NUMBER]: '',
  [FIELD_RECOVERY_EMAIL]: '',
}

export const RE_COLLECTION_POINT = 'AP'
export const CONSENT_MAP_RE_KEY = 'race/ethnicity'
export const CONSENT_OPT_IN = 'opt-in'
export const DATA_PROTECTED_STATES = ['CO', 'NJ', 'DE', 'OR', 'MN', 'MD', 'MT']

export const BFS_MINIMUM_AGE = 13
